import { useFriends } from './store';
import styles from './friends.module.css';

export function FriendRequests(): JSX.Element {
  const incoming = useFriends((s) => s.pendingIncoming);
  const outgoing = useFriends((s) => s.pendingOutgoing);
  const accept = useFriends((s) => s.acceptRequest);
  const reject = useFriends((s) => s.rejectRequest);

  if (incoming.length === 0 && outgoing.length === 0) {
    return (
      <div className={styles.emptyState}>
        No pending requests.
      </div>
    );
  }

  return (
    <div className={styles.requestList}>
      {incoming.length > 0 && (
        <>
          <div className={styles.sectionLabel}>Incoming</div>
          {incoming.map((r) => (
            <div key={r.from_id} className={styles.requestCard}>
              <span className={styles.friendName}>
                {r.display_name}
                <span className={styles.disc}>#{String(r.discriminator).padStart(4, '0')}</span>
              </span>
              <div className={styles.requestActions}>
                <button
                  className={styles.acceptBtn}
                  onClick={() => void accept(r.from_id)}
                >
                  Accept
                </button>
                <button
                  className={styles.rejectBtn}
                  onClick={() => void reject(r.from_id)}
                >
                  Reject
                </button>
              </div>
            </div>
          ))}
        </>
      )}
      {outgoing.length > 0 && (
        <>
          <div className={styles.sectionLabel}>Outgoing</div>
          {outgoing.map((r) => (
            <div key={r.to_id} className={styles.requestCard}>
              <span className={styles.friendName}>
                {r.display_name}
                <span className={styles.disc}>#{String(r.discriminator).padStart(4, '0')}</span>
              </span>
              <span className={styles.pendingLabel}>Pending</span>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
